export const USER_ID = process.env.REACT_APP_USER_ID;
export const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
